import { Component, Inject, ViewEncapsulation } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { RestrictionWarnSheetComponent } from '@sc/ui-components';
import {
  RestrictionWarnInputData,
  RestrictionWarnOutputData,
} from '@sc/data-access-models';

@Component({
  selector: 'sc-restriction-warn-bottom-sheet',
  styleUrls: ['./restriction-warn-bottom-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [RestrictionWarnSheetComponent],
  template: `
    <sc-restriction-warn-sheet
      [restrictionInfos]="data.restrictionInfos"
      [licensePlate]="data.licensePlate"
      (redirectEvent)="onRedirect($event)"
      (cancelEvent)="onCancel()"
    ></sc-restriction-warn-sheet>
  `,
})
export class RestrictionWarnBottomSheetComponent {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: RestrictionWarnInputData,
    private readonly bottomSheetRef: MatBottomSheetRef<
      RestrictionWarnBottomSheetComponent,
      RestrictionWarnOutputData
    >
  ) {}

  onRedirect(redirectUri: string) {
    this.bottomSheetRef.dismiss({ type: 'contact', redirectUri });
  }

  onCancel() {
    this.bottomSheetRef.dismiss({ type: 'cancel' });
  }
}
